import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-achievement-test',
  templateUrl: './achievement-test.component.html',
  styleUrls: ['./achievement-test.component.scss']
})
export class AchievementTestComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
